import { render, staticRenderFns } from "./MachineListItem.vue?vue&type=template&id=48afc38e&scoped=true&"
import script from "./MachineListItem.vue?vue&type=script&lang=js&"
export * from "./MachineListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afc38e",
  null
  
)

export default component.exports